import {useState} from "react";
import {useController, useFormContext} from "react-hook-form";

import {theme} from "Theme";
import {DECIMAL_SEPARATOR} from "base/format/config/i18n";
import {NumberUtil} from "base/format/utilities";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const getDecimalSize = value => {
    if (value.includes(DECIMAL_SEPARATOR)) {
        return value.split(DECIMAL_SEPARATOR)[1].length;
    }
    return 0;
};

const FormInputDecimal = ({
    name: propsName,
    label = "",
    tooltipText = "",
    placeholder = null,
    endAdornment = null,
    decimalSize = 2,
    rules = {},
    disabled = false,
}) => {
    const {control, trigger} = useFormContext();

    const {
        field,
        fieldState: {error},
    } = useController({
        name: propsName,
        control,
        rules: {
            ...rules,
        },
    });
    const [value, setValue] = useState(
        NumberUtil.formatDecimal(field.value, decimalSize)
    );

    const inputLabel = rules && rules["required"] ? `${label} *` : label;

    let inputProps = {};
    if (endAdornment) {
        inputProps = {
            ...inputProps,
            endAdornment: endAdornment && (
                <InputAdornment
                    position="end"
                    disableTypography
                    sx={{fontSize: theme.typography.fontSize}}
                >
                    {endAdornment}
                </InputAdornment>
            ),
        };
    }

    const handleBlur = event => {
        trigger(propsName);
        field.onBlur();
    };

    const getLabel = () => {
        return tooltipText ? (
            <Box display="flex" alignItems="center" marginRight="-8px">
                {inputLabel}
                {
                    <Tooltip title={tooltipText} arrow enterDelay={500}>
                        <InfoOutlinedIcon
                            fontSize="small"
                            sx={{mx: 1, color: "grey.500"}}
                        />
                    </Tooltip>
                }
            </Box>
        ) : (
            inputLabel
        );
    };

    return (
        <FormControl fullWidth error={Boolean(error)} margin={"dense"}>
            <TextField
                name={field.name}
                value={value}
                onChange={event => {
                    const userValue = NumberUtil.cleanDecimal(event.target.value);
                    if (getDecimalSize(userValue) <= decimalSize) {
                        field.onChange(NumberUtil.parseDecimal(userValue)); // data sent back to hook form
                        setValue(userValue); // UI state
                    }
                }}
                onBlur={handleBlur}
                inputRef={field.ref}
                label={getLabel()}
                placeholder={placeholder}
                InputLabelProps={{shrink: true}}
                InputProps={inputProps}
                disabled={disabled}
                error={Boolean(error)}
                helperText={error?.message}
            />
        </FormControl>
    );
};

export default FormInputDecimal;
